import { render } from "./editOpportunity.vue?vue&type=template&id=489b3852&scoped=true"
import script from "./editOpportunity.vue?vue&type=script&lang=js"
export * from "./editOpportunity.vue?vue&type=script&lang=js"

import "./editOpportunity.vue?vue&type=style&index=0&id=489b3852&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489b3852"]])

export default __exports__